import { render, staticRenderFns } from "./Labour.vue?vue&type=template&id=18ff847e&"
import script from "./Labour.vue?vue&type=script&lang=js&"
export * from "./Labour.vue?vue&type=script&lang=js&"
import style0 from "./Labour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports